import { companyReducer } from './reducers';

export default {
  company: companyReducer
};
